import { render, staticRenderFns } from "./WholeCalendarEventList.vue?vue&type=template&id=5bb3effc"
import script from "./WholeCalendarEventList.vue?vue&type=script&lang=js"
export * from "./WholeCalendarEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports